export const isScreenTooSmallForMeaningfulInteraction = (): boolean => window.screen.width < 768
